module.exports = __webpack_public_path__ + "static/media/CTLA_10-383w.a954deaa.jpg";